<template>
    
    <div>    
       <!--  <p>Id ES {{$route.params.id}}</p> -->
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a>
                    <router-link :to="{name:'r-/'}">Inicio</router-link>
                </a></li>
                <li class="breadcrumb-item active" aria-current="page">
                    Ofertas educativas
                </li>
                <li class="breadcrumb-item active li-actualizar-datos" aria-current="page" title="Actualizar datos" v-if="general.otros.app_modo=='online'" @click=obtener_recursos>
                    <i class="fa fa-refresh" aria-hidden="true"></i>
                </li>
            </ol>
        </nav>
        <div>
            <div class="row">
                <div class="col-12 mt-4">
                    <div class="card">
                        <div class="card-body" style="display:flex; flex-wrap: wrap;">
                            <div style="width: 100%; display:flex; justify-content:space-evenly;">
                                <button type="button" class="boton-3d-success" @click=boton_modal_registro>
                                    <i class='fa fa-plus' aria-hidden='true'></i>
                                    Nueva oferta
                                </button>
                                <!-- <button type="button" class="boton-3d-success" @click=boton_modal_registro_bancos>                                    
                                    Bancos
                                </button> -->
                            </div>       
                            <div v-if="datos.data_table.cargando" class="d-flex justify-content-center" style="width:100%; margin-top:1em; margin-bottom:1em; color:white;">
                                <div class="spinner-border" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>     
                            <div id="contenedor-tabla-registros" style="width: 100%;">
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>




        <!-- inicio modal registro -->
        <div class="modal fade bd-example-modal-lg" id="modal-registro">
            <div class="modal-dialog modal-lg">
                <div class="modal-content modal-3d">
                    <div class="modal-header">
                        
                        <h5>
                            Oferta educativa
                        </h5>

                        <button type="button" class="close" data-dismiss="modal"><span>&times;</span></button>
                    </div>
                    <div class="modal-body">
                        <div>
                            <div v-if="datos.registro_cargando" class="d-flex justify-content-center" style="width:100%; margin-top:1em; margin-bottom:1em; color:black;">
                                <div class="spinner-border" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                            <div class="form-row">
                                 
                                <div class="form-group col-md-12">
                                    <label for="inputEmail4">Nombre:</label> 
                                    <input type="text" maxlength="180" class="form-control input-3d" v-model=datos.registro.nombre>
                                </div>                                                                
                                
                            </div>                          
                        </div>
                    </div>
                    <div class="modal-footer">
                        
                        <button type="button" class="boton-3d-success" @click="enviar_datos">
                            Guardar
                        </button>
                        <button type="button" class="boton-3d-danger" data-dismiss="modal">
                            Cerrar
                        </button>

                    </div>

                </div>
            </div>
        </div>
        <!---fin modal registro---->               


    </div>

</template>

<script>
/* eslint-disable */
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'
import Swal   from '@/librerias/sweetalert2_9/sweetalert2_9.js'
//import { mapMutations } from 'vuex'

import * as calculos  from '@/librerias/lobato-calculos.js'

export default {
    name: 'com_general',
    props: {
        msg: String
    },
    data() {
    return {
        datos:{
            registro_cargando:false,
            registro:{
                id:'',
                nombre:'',
            },

            data_table:{
                cargando:false,
                registros:[]
            }
        }
    }
    },
    mounted(){
        /* let a=this.fecha_hoy;
        console.log('fecha 2 de hoy es');
        console.log(a); */

        //console.log('moneda es');
        //console.log(this.formato_moneda(5));
        this.inicial();
    },
    methods:{
        ...mapMutations(['funciones','alerta']),  
        //...mapActions(['formato_moneda']),
        inicial()
        {
            if(this.general.otros.autenticado===true)
            {
                //this.obtener_recursos();
                this.data_table();
            }
            else if(this.general.otros.autenticado===false)
            {
                this.$router.push('/login');
            }
        },  
        obtener_recursos()
        {
            this.data_table();
            fetch(`${this.general.otros.dominio_server}/cuentas_bancarias/recursos`,{
                method:'GET',
                //body:JSON.stringify( this.datos.registro ),
                headers:{
                    'Accept'        :'application/json',
                    'Content-Type'  :'application/json',
                    //'Authorization' :`Bearer ${this.general.otros.token}`
                    //'X-CSRF-TOKEN':this.general.otros.csrf
                },
                credentials: 'include',                   
            })
            .then(res=>res.json())
            .then(respuesta=>{
                
                console.log('recursos');
                console.log(respuesta);
                //this.datos.bancos.todos=respuesta.datos.bancos;

            })
            .catch(error=>{
                this.funciones({nombre:'alerta',estatus:'error',mensaje:`No pudo obtenerse los recursos`});
            })
            .finally( () => {
                //this.datos.data_table.cargando=false;                
            });
        },    
        boton_modal_registro()
        {
            for (const p in this.datos.registro) {                    
                                
                this.datos.registro[p]='';                
                
            }                             

            this.funciones({nombre:'sonido',sonido:this.general.sonidos.abrir});
            $("#modal-registro").modal("show");
        },
        data_table()
        {
            this.datos.data_table.cargando=true;            
            fetch(`${this.general.otros.dominio_server}/educacion_ofertas/todos`,{
                method:'GET',
                //body:JSON.stringify( this.datos.registro ),
                headers:{
                    'Accept'        :'application/json',
                    'Content-Type'  :'application/json',
                    //'Authorization' :`Bearer ${this.general.otros.token}`
                    //'X-CSRF-TOKEN':this.general.otros.csrf
                },
                credentials: 'include',                   
            })
            //.then(res=>res.json())
            .then(res => {
                if (res.status == 200) 
                {
                    return res.json();
                }
                else
                {
                    throw new Error(`Error: ${res.status}`);
                }
            })
            .then(respuesta=>{
                
                this.datos.data_table.registros=respuesta.datos;                
                this.data_table_crear();
            })
            .catch(error=>{
                this.funciones({nombre:'alerta',estatus:'error',mensaje:`No pudo obtenerse los datos`});
            })
            .finally( () => {
                this.datos.data_table.cargando=false;                
            });
        },
        data_table_crear()
        {
            document.getElementById('contenedor-tabla-registros').innerHTML=`
                <table id="tabla-registros" class="table table-hover w-100 pb-30">
                    <thead>
                        <tr>
                            <th style="width:10%;">Id</th>
                            <th>Nombre</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody >
                    </tbody>
                    <tfoot>
                        <tr>
                            <th>Id</th>
                            <th>Nombre</th>
                            <th>Acciones</th>
                        </tr>
                    </tfoot>
                </table>
            `;
            $('#tabla-registros thead tr').clone(true).appendTo( '#tabla-registros thead' );
            $('#tabla-registros thead tr:eq(1) th').each( function (i) {
                var title = $(this).text();
                $(this).html( '<input class="form-control" style="width:100%;font-size:11px;" type="text" placeholder="Buscar '+title+'" />' );
        
                $( 'input', this ).on( 'keyup change', function () {
                    if ( tabla_registros.column(i).search() !== this.value ) {
                        tabla_registros
                            .column(i)
                            .search( this.value )
                            .draw();
                    }
                } );
            } );
            
            var tabla_registros=$('#tabla-registros').DataTable({
                orderCellsTop: true,
                fixedHeader: true,
                responsive: true,
                autoWidth: true,
                "order":[0,'desc'],
                language: {
                    search: "Buscar",
                    searchPlaceholder: "Buscar",
                    lengthMenu: "Mostrando _MENU_ registros por página",
                    zeroRecords: "No se encontraron registros",
                    info: "Mostrando pagina _PAGE_ de _PAGES_",
                    infoEmpty: "No hay registros disponibles",
                    infoFiltered: "(filtrando de _MAX_ registros)",
                    paginate: {
                        "first":      "First",
                        "last":       "Last",
                        next:       "Siguiente",
                        previous:   "Anterior"
                    },
                },
                //ajax:`/ordenes_elaboracion_materiales/todos`,
                //ajax:`/clientes/todos`,
                data:this.datos.data_table.registros,                
                columnDefs:[
                    {"targets":0, "data":function(data,type,full,meta)
                        {
                            return data.id;
                        }
                    }, 
                    {"targets":1, "data":function(data,type,full,meta)
                        {                            
                            //return this.general_no_xss(data.nombre);
                            return data.nombre;
                        }
                    }, 
                    {"targets":2, "data":(data,type,full,meta)=>
                        {
                            let acciones=``;                            

                            acciones+=`
                                <button registro-id='${data.id}' class="boton_modal_editar_registro boton-3d-info" style="margin-right:1em;">                                    
                                    <i registro-id='${data.id}' class="fa fa-pencil-square-o" aria-hidden="true"></i>                                    
                                </button>
                                <button registro-id='${data.id}' class="boton_modal_remover_registro boton-3d-danger" style="margin-right:1em;">
                                    <i registro-id='${data.id}' class='fa fa-times' aria-hidden='true'></i>                                    
                                </button>
                            `;

                            return `
                                <div style="display:flex; justify-content:left;">
                                    ${acciones} 
                                </div>
                            `;
                        }
                    }
                ],
                "drawCallback": this.eventos_data_table
            });
            tabla_registros.on( 'responsive-display',  ( e, datatable, row, showHide, update ) => {               
                this.eventos_data_table();
            } );
            
        },
        eventos_data_table()
        {
            Array.from(document.getElementsByClassName("boton_modal_editar_registro")).forEach((item)=>{
                item.addEventListener('click',this.boton_modal_editar_registro_evento);
            });

            Array.from(document.getElementsByClassName("boton_modal_remover_registro")).forEach((item)=>{
                item.addEventListener('click',this.boton_modal_remover_registro);
            });
        },


        boton_modal_remover_registro(item)
        {
            //this.datos.registro.i            
            this.datos.registro.id=calculos.atributo(item,'registro-id');
            Swal.fire({
                title: `¿ Remover registro id : ${this.datos.registro.id} ?`,
                text: "",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Si, remover ahora",
                cancelButtonText:'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) 
                {
                    this.alerta({titulo:'Procesando datos',mensaje:'espere ...'});  
                    fetch(`${this.general.otros.dominio_server}/educacion_ofertas/registro/remover`,{
                        method:'POST',
                        body:JSON.stringify( {
                            id:this.datos.registro.id
                        } ),
                        headers:{                    
                            //'X-CSRF-TOKEN':this.general.otros.csrf
                            'Content-Type'  :'application/json',
                            'Accept'        :'application/json',
                            //'Authorization' :`Bearer ${this.general.otros.token}`
                        },
                        credentials: 'include',                   
                    })
                    //.then(res=>res.json())
                    .then(res => {
                        if (res.status == 200) 
                        {
                            return res.json();
                        }
                        else
                        {
                            throw new Error(`Error: ${res.status}`);
                        }
                    })
                    .then(respuesta=>{
                        let dt={
                            'bien':()=>{                        
                                //this.data_table();
                                //$("#modal-registro").modal("hide");
                                this.funciones({nombre:'alerta',estatus:'success',mensaje:`Registro removido`});
                            }
                        };

                        if(respuesta.mensaje in dt )
                        {
                            dt[respuesta.mensaje]();
                        }                
                    })
                    .catch(error=>{
                        this.funciones({nombre:'alerta',estatus:'error',mensaje:`No se pudo remover`});
                    })
                    .finally( () => {
                        this.data_table();
                        //this.datos.data_table.cargando=false;
                    });
                }
            });
        },
        boton_modal_editar_registro_evento(item)
        {        
            this.boton_modal_registro();
            this.datos.registro.id=item.target.getAttribute('registro-id');  
            this.datos.registro_cargando=true;        
            //fetch(`${this.general.otros.dominio}/productos/${this.datos.registro.id}/datos`)
            fetch(`${this.general.otros.dominio_server}/educacion_ofertas/${this.datos.registro.id}/datos`,{
                method:'get',                
                headers:{                    
                    //'Content-Type':'application/json',
                    //'X-CSRF-TOKEN':this.general.otros.csrf
                    'Content-Type'  :'application/json',
                    'Accept'        :'application/json',
                    //'Authorization' :`Bearer ${this.general.otros.token}`
                },
                credentials: 'include',                   
            })
            //.then(res=>res.json())
            .then(res => {
                if (res.status == 200) 
                {
                    return res.json();
                }
                else
                {
                    throw new Error(`Error: ${res.status}`);
                }
            })
            .then(respuesta=>{

                if(respuesta.datos.oferta.length>0)
                {
                    let c=respuesta.datos.oferta[0];
                    let r=this.datos.registro;

                    r.nombre    =c.nombre;
                }

            })
            .catch(error=>{
                this.funciones({nombre:'alerta',estatus:'error',mensaje:`No se pudo obtener la información`});
            })
            .finally( () => {
                this.datos.registro_cargando=false;
            });
            
        },                     
        
        enviar_datos(a)
        {
            this.alerta({titulo:'Procesando datos',mensaje:'espere ...'}); 
            fetch(`${this.general.otros.dominio_server}/educacion_ofertas/registro`,{
                method:'POST',                
                body:JSON.stringify(this.datos.registro),
                headers:{                    
                    //'X-CSRF-TOKEN':this.general.otros.csrf
                    'Content-Type'  :'application/json',
                    'Accept'        :'application/json',
                    //'Authorization' :`Bearer ${this.general.otros.token}`
                },
                credentials: 'include',                   
            })
            //.then(res=>res.json())
            .then(res => {
                if (res.status == 200) 
                {
                    return res.json();
                }
                else
                {
                    throw new Error(`Error: ${res.status}`);
                }
            })
            .then(respuesta=>{
                let dt={
                    'bien':()=>{                        
                        //this.data_table();
                        $("#modal-registro").modal("hide");
                        this.funciones({nombre:'alerta',estatus:'success',mensaje:`Guardado`});
                    }
                };

                if(respuesta.mensaje in dt )
                {
                    dt[respuesta.mensaje]();
                }                
            })
            .catch(error=>{
                this.funciones({nombre:'alerta',estatus:'error',mensaje:`La cuenta no se pudo guardar`});
            })
            .finally( () => {
                this.data_table();
                //this.datos.data_table.cargando=false;
            });
        },
    },
    computed: {
        ...mapState(['general']),
        ...mapGetters([
            'general_fecha_hoy',
            'general_no_xss',
            'general_formato_moneda'
        ]),
    },
    watch: {
        'general.otros.autenticado': function (v) {
            if(v)
            {
                this.inicial();
            }
        }
    }
}
</script>

<style lang="scss" scoped>        
    .contenedor-producto{
        background:linear-gradient(90deg, #0093ff, #484848);
        border-radius:7px; 
        margin-bottom:1em; 
        padding:1em;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.8);
        padding-bottom:0px; 
        padding-top:0.5em;

        /* &:hover{
            background:linear-gradient(90deg, #01253f, #1d1c1c);
        } */

        label {
            color:white;
        }
    }
    #modal_movimientos{
        #contenedor_img_bancos{
            height:100%;
            display:flex;
            align-items:center;
            img{
                width:150px;
            }
        }
        #contenedor_tabla_ultimos_movimientos{
            height:300px; 
            overflow:scroll;

            .fecha_creacion{
                font-size:0.8em;
                font-weight:bold;
                margin:0px;
            }
            .hora_creacion{
                font-size:0.8em;
                font-weight:bold;
            }
            .descripcion{
                font-size:1em;
                margin:0px;
            }
            .contenedor-cantidad-remover{
                display:flex;
                flex-wrap:wrap;
                justify-content:right;
                height:100px;
                align-content:space-between;
                .cantidad{
                    font-size:1.5em;
                    width:100%;
                    text-align:right;
                }
            }
            .cantidad_restar{
                color:red;
            }
            
        }
    }
    
</style>